import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../interseptor/axiosConf";



function fetchPageData(page_id){
    const beURL = localStorage.getItem('BeURL');
    return axios.get(`/api/get/content/${page_id}`).then(res => res.data);
}

export const usePageData =(enabled,id)=>{

    return useQuery({
        queryKey: [`pageData-${id}`],
        queryFn:()=> fetchPageData(id),
        enabled,

    })
}

export const useAddPage =()=>{

    return useMutation({
        mutationFn: async (newPage)=>{
            const { data } = await axios.post('/api/create/page', newPage);
            return data;
        }
    })
}

export const useUpdatePage=()=>{
     return useMutation({
        mutationFn: async (data) => {
            const id = data.page_id
            const response = await axios.put(`/api/update/page/${id}`, data);
            return response.data;
        }
     }
        
    );

}